import { Navigate, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { AppShell } from './layout/AppShell'
import { LandingPage } from './screens/LandingPage'
import { LoginPage, SignUpPage } from './screens/AuthPages'
import { HomePage } from './screens/HomePage'
import { DetailsPage } from './screens/DetailsPage'
import { HistoryPage } from './screens/HistoryPage'
import { ReportPage } from './screens/ReportPage'
import { SettingsPage } from './screens/SettingsPage'
import type { RootState } from './store'

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const token = useSelector((s: RootState) => s.auth.accessToken)
  if (!token) return <Navigate to="/login" replace />
  return children
}

function PublicOnly({ children }: { children: React.ReactNode }) {
  const token = useSelector((s: RootState) => s.auth.accessToken)
  if (token) return <Navigate to="/app" replace />
  return children
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/login"
        element={
          <PublicOnly>
            <LoginPage />
          </PublicOnly>
        }
      />
      <Route
        path="/signup"
        element={
          <PublicOnly>
            <SignUpPage />
          </PublicOnly>
        }
      />
      <Route
        path="/app"
        element={
          <PrivateRoute>
            <AppShell />
          </PrivateRoute>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="vehicles/:vehicleId" element={<DetailsPage />} />
        <Route path="vehicles/:vehicleId/onboard" element={<DetailsPage />} />
        <Route path="history" element={<HistoryPage />} />
        <Route path="reports" element={<ReportPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
